import { CoreStore, handleStoreState } from "./CoreStore";
import { observable, action, runInAction, makeObservable } from "mobx";
import { API } from "General/API";
import { FetchError } from "General/ErrorTypes";

export abstract class SubmitStore<T extends object> extends CoreStore {
  data: T = {} as T;

  constructor() {
    super();

    makeObservable(this, {
      data: observable,
      update: action.bound,
      // clear: action.bound,
      handleFetchErrors: action,
      processData: action,
      submit: action,
    });
  }

  update(newData: T) {
    this.data = { ...(this.data as object), ...(newData as object) } as T;
  }

  clear() {
    this.data = {} as T;
  }

  @handleStoreState()
  async submit(formData: T, mergeWithData = true) {
    try {
      let postObject: object = {};
      if (mergeWithData) {
        postObject = { ...(this.data as object), ...(formData as object) } as T;
      } else {
        postObject = formData;
      }
      const response: T = await API.newData(this.url(), postObject).then((res) => this.processData(res));
      runInAction(() => {
        this.data = response;
      });
    } catch (error) {
      this.handleFetchErrors(error);
      throw error;
    }
  }

  handleFetchErrors(err: FetchError | Error) {
    throw err;
  }

  processData(data: T) {
    return data;
  }
}
